import { TranslationContext } from 'contexts/TranslationContext'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import Button from '~/components/base/Button'
import {
  Dialog,
  DialogContent,
  DialogTitle
} from '~/components/base/Dialog/Dialog'
import { InputClearable } from '~/components/base/InputClearable/InputClearable'
import { DUPLICATED_PROJECT_NAME_POSTFIX, START_PAGE } from '~/constant'
import './ProjectSaveAsDialog.scss'

export const ProjectSaveAsDialog = ({
  modalDialog,
  projectName,
  isAskProjectName,
  isNewProject,
}) => {
  const [ name, setName ] = useState(
    () => __CFG__.START_PAGE === START_PAGE.PROJECTS
      ? ''
      : `${isNewProject ? '' : `${projectName}${DUPLICATED_PROJECT_NAME_POSTFIX}`}`
  )

  const handleChangeName = ({ target: { value } }) => {
    setName(value)
  }

  const handleClearName = () => {
    setName('')
  }

  const handleSave = useCallback(() => {
    modalDialog.confirm(name)
  }, [ modalDialog, name ])

  useEffect(() => {
    setName((isNewProject || isAskProjectName) ? '' : `${projectName}${DUPLICATED_PROJECT_NAME_POSTFIX}`)
  }, [ projectName, isAskProjectName, isNewProject ])

  const { t } = useContext(TranslationContext)

  useEffect(() => {
    const onKeyDown = e => {
      if (modalDialog.active && e.key === 'Enter') {
        if (isAskProjectName) {
          if (name) {
            handleSave()
          }
        } else {
          handleSave()
        }
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [ handleSave, modalDialog.active, name, isAskProjectName ])

  return (
    <If condition={modalDialog.active}>
      <Dialog
        className="save-as-dialog"
        open
        modalDialog={modalDialog}
        onClose={modalDialog.cancel}
      >
        <DialogTitle className="save-as-dialog__header">
          {isNewProject
            ? t('EDITOR_MENU_LIST_ITEM_NEW_PROJECT')
            : t('EDITOR_MENU_LIST_ITEM_SAVE_PROJECT_AS')}
        </DialogTitle>
        <DialogContent className="save-as-dialog__content">
          <InputClearable
            placeholder={t('PROJECTS_SAVE_INPUT_PLACEHOLDER_PROJECT_NAME')}
            onChange={handleChangeName}
            value={name}
            onClearInput={handleClearName}
            onKeyDown={e => {
              if (e.key === 'Escape') {
                modalDialog.cancel()
              }
            }}
          />

          <Button
            type="submit"
            className="save-as-dialog__button"
            primary
            onClick={handleSave}
            autoFocus
            disabled={isAskProjectName ? !name : false}
          >
            {isNewProject ? t('PROJECTS_BTN_CREATE') : t('PROJECTS_BTN_SAVE')}
          </Button>
        </DialogContent>
      </Dialog>
    </If>
  )
}
